import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import YouTube from "@u-wave/react-youtube"
import Vimeo from "@u-wave/react-vimeo"
import { theme } from "Theme"
import { mixins } from "Styles"
import { Utils, ActionButton, ActionButtonAlt, LinkButtonAlt, ActionButtonV1 } from "Components"
import Config from "Data"
import Typewriter from "typewriter-effect"
import AnimatedBg from "react-animated-bg"




const Wrapper = styled.div`
  justify-content: flex-end;
  background: ${theme.colors.black.base};
  padding-top: ${theme.headerScrollHeight};
  canvas {
    opacity: 1;
  }
  min-height: 65vh;
  align-items: center;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    height: ${(props) => (props.height ? `${props.height}vh` : `60vh`)};
    ${(props) => (props.justify ? `justify-content:${props.justify}` : `space-between`)};
    align-items: ${(props) => (props.event ? `center` : `flex-end`)};
    min-height: auto;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 0;
`

const Content = styled.div`
  color: ${theme.colors.white.base};
  text-align: ${(props) => (props.event ? `center` : `left`)};
  height: 100%;
  width: 100%;
  max-width: ${theme.layout.base};
  position: relative;
  z-index: 3;
  padding: ${(props) => (props.event ? `1rem` : `0 1rem`)};
  margin: 2rem 0;
  display: grid;
  align-content: ${(props) => (props.justify ? `center` : `stretch`)};
  align-items: ${(props) => (props.justify ? `center` : `end`)};
  @media (min-width: ${theme.breakpoints.s}) {
    padding: ${(props) => (props.event ? `1rem` : `0 2rem`)};
  }
  @media (min-width: ${theme.breakpoints.m}) {
    margin: 4rem auto ${(props) => (props.featured ? `5rem` : props.event ? `4rem` : `2rem`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const SubContent = styled.div`
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const StyledImg = styled(GatsbyImage)`
  position: initial !important;
  left: 0;
  top: 0;
  &.blur {
    img {
      filter: blur(4px);
    }
  }
  @keyframes zoomAnimation {
    50% {
      -webkit-transform: scale(1.2);
      -moz-transform: scale(1.2);
      -ms-transform: scale(1.2);
      -o-transform: scale(1.2);
      transform: scale(1.2);
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
    img {
      animation: ${(props) => (props.animated ? "zoomAnimation 80s linear infinite" : "none")};
    }
  }
`

const Title = styled.h1`
  color: inherit;
  font-weight: normal;
  position: relative;
  text-align: ${(props) => (props.event ? `center` : `left`)};
  width: 100%;
  height: ${(props) => (props.event ? `250px` : `100%`)};
  &.mb-0 {
    margin-bottom: 0;
  }
  .content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 2.2rem;
    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
      font-size: 3.2rem;
    }
    @media (min-width: ${theme.breakpoints.l}) {
    }
  }
  font-size: 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    font-size: 3rem;
    max-width: ${(props) => (props.event ? `auto` : `auto`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .Typewriter {
    display: inline-block;
  }
`


const TitleAlt1 = styled.h1`
  color: inherit;
  font-weight: normal;
  position: relative;
  text-align: ${(props) => (props.event ? `center` : `left`)};
  width: 100%;
  height: ${(props) => (props.event ? `250px` : `100%`)};
  &.mb-0 {
    margin-bottom: 0;
  }
  .content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 2.2rem;
    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
      font-size: 3.8rem;
    }
    @media (min-width: ${theme.breakpoints.l}) {
    }
  }
  font-size: 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    font-size: 3rem;
    max-width: ${(props) => (props.event ? `auto` : `auto`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .Typewriter {
    display: inline-block;
  }
`
const TitleAlt = styled.h1`
  color: inherit;
  font-weight: bold;
  position: relative;
  text-align: ${(props) => (props.event ? `center` : `left`)};
  width: 100%;
  height: ${(props) => (props.event ? `250px` : `100%`)};
  margin-bottom: 2rem;
  .content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 2.2rem;
    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
      font-size: 4rem;
    }
    @media (min-width: ${theme.breakpoints.l}) {
    }
  }
  font-size: 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    font-size: 3rem;
    max-width: ${(props) => (props.event ? `auto` : `auto`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .Typewriter {
    display: inline-block;
  }
`
const SubtitleAlt = styled.h1`
  color: inherit;
  font-size: ${theme.fontSize.h5};
  font-weight: normal;
  position: relative;
  text-align: ${(props) => (props.event ? `center` : `left`)};
  margin: ${(props) => (props.event ? `0 auto` : `auto 0`)};
  &.mb-0 {
    margin-bottom: 0;
  }
  
`
const SubtitleOptionPage = styled.p`
  color: inherit;
  font-size: ${theme.fontSize.h7};
  font-weight: normal;
  position: relative;
  text-align: ${(props) => (props.event ? `center` : `left`)};
  margin: ${(props) => (props.event ? `0 auto` : `auto 0`)};
  &.mb-0 {
    margin-bottom: 0;
  }
  /* width:60%; */
  @media (min-width: ${theme.breakpoints.s}) {
    width :100%
  }
  @media (min-width: ${theme.breakpoints.m}) {
    /* width :100% */
    }
`
const Subtitle = styled.p`
  color: inherit;
  font-size: ${theme.fontSize.h6};
  font-weight: normal;
  position: relative;
  text-align: ${(props) => (props.event ? `center` : `left`)};
  margin: ${(props) => (props.event ? `0 auto` : `auto 0`)};
  &.mb-0 {
    margin-bottom: 0;
  }
  width:60%
`

const Animated = styled.span`
  font-weight: bold;
  position: relative;
  width: 100%;
  text-align: left;
  display: block;
  font-size: ${theme.fontSize.h3};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    font-size: inherit;
    display: inline;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const BrandedColor = styled.span`
  color: ${Utils.BrandColor(Config.brand.toLowerCase())};
`
const BrandedColorAlt = styled.span`
  color: ${Utils.BrandColor(Config.brand.toLowerCase())};
`

const BrandTitle = styled.span`
font-weight : bold;
`

const BrandName = (props) => {
  let title = '';
  let subTitle = '';
  switch (props.event_type?.toLowerCase()) {
    case 'CIOsynergy':
    case 'CIOcamps':
    case 'ciocamps':
      title = 'CIO';
      subTitle = 'camps';
      break;
    case 'SECUREcamps':
    case 'securecamps':
      title = 'SECURE';
      subTitle = 'camps';
      break;
    case 'secureciso':
    case 'CISOcamps':
    case 'cisocamps':
      title = 'CISO';
      subTitle = 'camps';
      break;
    case 'CFOcamps':
    case 'cfocamps':
      title = 'CFO';
      subTitle = 'camps';
      break;
    case 'CMOcamps':
    case 'cmocamps':
      title = 'CMO';
      subTitle = 'camps';
      break;
  }
  return (
    <BrandTitle>
      <BrandedColorAlt color={props.event_type}>{title}</BrandedColorAlt>{subTitle}
    </BrandTitle>)
}
const ContentWrapper = ({ props }) => {
  return (
    <Content featured={props.featured} event={props.event} justify={props.justify}>
      <>
        <SubContent>
          {props.title && props.title !== "null" && !props.event_type && !props.countries && !props.titles && (
            <div>
              {props.option_page ? (<TitleAlt1 event={props.event}>
                <div className={!props.subtitle ? "content mb-0" : "content"}>
                  {props.title}
                  {props.event && <span>{props.event.city}</span>}
                </div>
              </TitleAlt1>) : (<Title event={props.event}>
                <div className={!props.subtitle ? "content mb-0" : "content"}>
                  {props.title}
                  {props.event && <span>{props.event.city}</span>}
                </div>
              </Title>)}

              {props.title_1 && (
                <TitleAlt event={props.event}>
                  <div className={props.subtitle ? "content mb-2" : "content"}>
                    {props.title_1}

                  </div>
                </TitleAlt>)}
            </div>
          )}

          {
            props.title && props.event_type && !props.countries && (
              <Title>
                <BrandName event_type={props.event_type} />
                <span> {props.title} </span>
              </Title>
            )
          }
          {props.title && props.event_type && props.countries && (
            <Title>
              <BrandName event_type={props.event_type} />
              <span> {props.title} </span>
              <BrandedColor>
                <Animated>
                  <Typewriter
                    options={{
                      strings: Config.countries,
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </Animated>
              </BrandedColor>
            </Title>
          )
          }


          {props.title && props.title !== "null" && !props.event_type && props.countries && (
            <Title>
              <span>{props.title}</span>{" "}
              <BrandedColor>
                <Animated>
                  <Typewriter
                    options={{
                      strings: Config.countries,
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </Animated>
              </BrandedColor>
            </Title>
          )}

          {props.title && props.title !== "null" && props.titles && (
            <Title>
              <span>{props.title}</span>
              <Animated>
                <Typewriter
                  options={{
                    strings: Config.titles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Animated>
            </Title>
          )}

          {props.option_page && !props.event && props.subtitle !== "null" && props.title !== "null" && (
            <SubtitleOptionPage className={!props.children ? "mb-0" : ""} event={props.event}>
              {props.subtitle}
            </SubtitleOptionPage>
          )}

          {!props.option_page && !props.event && props.subtitle !== "null" && props.title !== "null" && (
            <Subtitle className={!props.children ? "mb-0" : ""} event={props.event}>
              {props.subtitle}
            </Subtitle>
          )}

          {!props.option_page && !props.event && props.subtitle && props.title === "null" && (
            <SubtitleAlt className={!props.children ? "mb-0" : ""} event={props.event}>
              {props.subtitle}
            </SubtitleAlt>
          )}
        </SubContent>
      </>

      {props.children}

      {!props.event &&
        (props.options_cta_action1_text || props.cta_action1_text || props.cta_action2_text || props.cta_url1_text || props.cta_url2_text) && (
          <div style={{ marginTop: "2rem" }}>
            {props.options_cta_action1 && props.options_cta_action1_text && props.options_cta_action1_text !== "null" && (
              <ActionButtonV1
                onClick={props.options_cta_action1}
                track={props.track}
                title={`${props.title} | ${props.options_cta_action1_text}`}>
                {props.options_cta_action1_text}
              </ActionButtonV1>
            )}
            {props.cta_action1 && props.cta_action1_text && props.cta_action1_text !== "null" && (
              <ActionButton
                onClick={props.cta_action1}
                track={props.track}
                title={`${props.title} | ${props.cta_action1_text}`}>
                {props.cta_action1_text}
              </ActionButton>
            )}
            {props.cta_action2 && props.cta_action2_text && props.cta_action2_text !== "null" && (
              <ActionButtonAlt
                onClick={props.cta_action2}
                track={props.track}
                title={`${props.title} | ${props.cta_action2_text}`}>
                {props.cta_action2_text}
              </ActionButtonAlt>
            )}
            {props.cta_url1 && props.cta_url1_text && props.cta_url1_text !== "null" && (
              <LinkButtonAlt to={props.cta_url1} track={props.track} title={`${props.title} | ${props.cta_url1_text}`}>
                {props.cta_url1_text}
              </LinkButtonAlt>
            )}
            {props.cta_url2 && props.cta_url2_text && props.cta_url2_text !== "null" && (
              <LinkButtonAlt to={props.cta_url2} track={props.track} title={`${props.title} | ${props.cta_url2_text}`}>
                {props.cta_url2_text}
              </LinkButtonAlt>
            )}
          </div>
        )}
    </Content>
  )
}

const Dim = () => (
  <div
    style={{
      backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4))",
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      position: "absolute",
      top: 0,
      zIndex: 3,
    }}></div>
)

const ColorDim = (color) => (
  <div
    style={{
      background: color ? `${Utils.BrandColor(color.color.toLowerCase())}` : `${mixins.backgroundBefore}`,
      opacity: color ? `0.5` : `1`,
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      position: "absolute",
      top: 0,
      zIndex: 1,
    }}></div>
)
const ColorPlainDim = ({ colorPlain }) => {
  return (
    <div
      style={{
        background: colorPlain,
        opacity: colorPlain ? `0.5` : `1`,
        width: "100%",
        height: "100%",
        backgroundSize: "cover",
        position: "absolute",
        top: 0,
        zIndex: 1,
      }}></div>
  )
}
const HeroBrand = (props) => {
  const slides = []
  var imagesArray = props.backgrounds?.nodes?.filter((item) => props.backgroundsArray.includes(item.name))

  imagesArray?.map((node) => {
    slides.push(`url('${node.childImageSharp.gatsbyImageData.images.fallback.src}')`)
  })

  return (
    <Wrapper
      height={props.height}
      justify={props.justify}
      event={props.event}
      animated={props.animated}
      className={`hero-section`}
      color={props.color}>
      {props.vimeoId && !props.youtubeId && (
        <div className="video-background">
          <div className="video-foreground">
            <Vimeo
              video={props.vimeoId}
              width={640}
              height={480}
              autoplay
              volume={0}
              loop={true}
              background={true}
              controls={false}
              className="video-iframe"
            />
          </div>
        </div>
      )}
      {!props.vimeoId && props.youtubeId && (
        <div className="video-background">
          <div className="video-foreground">
            <YouTube
              video={props.youtubeId}
              width={640}
              height={480}
              autoplay
              volume={0}
              loop={1}
              background={true}
              controls={false}
              className="video-iframe"
              showRelatedVideos={false}
            />
          </div>
        </div>
      )}
      {props.color && <ColorDim color={props.color} />}
      {props.colorPlain && <ColorPlainDim colorPlain={props.colorPlain} />}
      {props.image && (
        <>
          <StyledImg
            alt={""}
            title={`${Config.brand} | ${Config.brandBusiness} by ${Config.contact.name}`}
            image={props.image}
            animated={props.animated}
            className={props.blur ? "blur" : ""}
          />
          {(!props.color && !props.colorPlain) && <Dim />}
          {props.color && <ColorDim color={props.color} />}
          {props.colorPlain && <ColorPlainDim color={props.colorPlain} />}
        </>
      )}
      {slides.length > 0 && (
        <>
          <AnimatedBg
            colors={slides}
            duration={4}
            delay={6}
            timingFunction="ease-out"
            className="animated-section animated-images"></AnimatedBg>
        </>
      )}
      {!props.image && !props.vimeoId && !props.youtubeId && <span></span>}
      <ContentWrapper props={props} />
    </Wrapper>
  )
}

export default HeroBrand

HeroBrand.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  image: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  animated: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
  dark: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
}

HeroBrand.defaultProps = {
  children: false,
  image: false,
  animated: false,
  title: false,
}
